// extracted by mini-css-extract-plugin
export default {"roundIntroView":"RoundIntro_roundIntroView__-taBY","background":"RoundIntro_background__qICUH","screen":"RoundIntro_screen__aBDQV","show":"RoundIntro_show__vSQlR"};